import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import customerService from "../Services/customerService";
import uploadService from "../Services/uploadService";
import { LoadingDots } from "../Components/LoadingDots";
import Dropdown from "../Components/Dropdown";
import { HiPlus } from "react-icons/hi";

const AddCustomer = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState();
  const [responseError, setResponseError] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    designation: "",
    company_name: "",
    warehouse_address: "",
    company_type: "",
    phone_number: "",
    rep_name: "",
    trn: "",
    terms: "",
    rep_phone: "",
    // rep_email: "",
    office_address: "",
    email: "",
    // reference: "",
    license: "",
  });

  const [errors, setErrors] = useState({
    first_name: false,
    last_name: false,
    phone_number: false,
    email: false,
    designation: false,
    company_type: false,
    company_name: false,
    warehouse_address: false,
    rep_name: false,
    trn: false,
    terms: false,
    rep_phone: false,
    office_address: false,
    // rep_email: false,
    // reference: false,
    license: false,
  });

  const [regex, setRegex] = useState({
    first_name: /.{1,50}$/,
    last_name: /.{1,50}$/,
    phone_number: /^\+?[0-9]{7,15}$/,
    email: /^[\w\.\-]+@[a-zA-Z\d\-]+\.[a-zA-Z]{2,}$/,
    designation: /.{1,50}$/,
    company_type: /.{1,50}$/,
    company_name: /.{1,50}$/,
    warehouse_address: /.{1,50}$/,
    rep_name: /.{1,50}$/,
    rep_phone: /^\+?[0-9]{7,15}$/,
    trn: /^\+?[0-9]{1,100}$/,
    terms: /.{1,50}$/,
    office_address: /.{1,50}$/,
    // rep_email: /.{1,50}$/,
    // reference: /.{1,50}$/,
    license: /.{1,50}$/,
  });

  // const [isTermsOpen, setIsTermsOpen] = useState(false);
  // const dropdownRef = useRef();

  const [selectedTerm, setSelectedTerm] = useState(null); // for selected option
  const [isTermsOpen, setIsTermsOpen] = useState(false); // for dropdown visibility
  const dropdownRef = useRef(null); // for click-outside logic

  const options = [
    { label: "Cash", value: "cash" },
    { label: "Credit", value: "credit" },
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsTermsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChange = (v, n) => {
    setResponseError("");
    setData((d) => ({ ...d, [n]: v }));
    if (v.length > 0) {
      setErrors((prevState) => ({ ...prevState, [n]: false }));
    }
  };

  const convertToBase64 = (e) => {
    const reader = new FileReader();
    if (e.target.files.length > 0) {
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        setErrors((errors) => ({ ...errors, license: false }));
        setFile(e.target.files[0]);
        setData((data) => ({ ...data, license: reader.result }));
      };
    }
  };

  const handleSubmit = () => {
    let hasError = false;
    Object.keys(data).map((v) => {
      if (!regex[v]?.test(data[v])) {
        setErrors((prevState) => ({ ...prevState, [v]: true }));
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Please fill the form correctly", { id: "1" });
    } else {
      setLoading(true);
      uploadService.single(file).then((res) => {
        let form = { ...data, license: res.response.url };
        customerService.create(form).then((res) => {
          setLoading(false);
          if (res.responseCode === 409) {
            toast.error("Email already used");
            setResponseError(res.message);
          } else {
            toast.success("Customer Added Successfully", { id: "2" });
            navigate("/customers");
          }
        });
      });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  const dropdownOption = ["Cash", "Credit"].map((option) => ({
    label: option,
    value: option,
  }));
  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
      <h1 className="font-bold text-center text-3xl text-secondary mt-10">
        Add Customer
      </h1>

      <div className="mt-10 px-80">
        <div className="grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-4">
          <div>
            <label className={`primary-label`}>First Name</label>
            <input
              value={data.first_name}
              name="first_name"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              onKeyDown={handleKeyDown}
              placeholder="First Name"
              className={`primary-input ${
                errors["first_name"] ? "border-red-600" : ""
              }`}
            />
          </div>
          <div>
            <label className={`primary-label`}>Last Name</label>
            <input
              value={data.last_name}
              name="last_name"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Last Name"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["last_name"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className={`primary-label`}>Email</label>
            <input
              value={data.email}
              name="email"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Email"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["email"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>

          <div>
            <label className={`primary-label`}>Designation</label>
            <input
              value={data.designation}
              name="designation"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Designation"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["designation"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2 md:grid-cols-5 md:gap-4 mt-4">
          <div>
            <label className={`primary-label`}>Phone Number</label>
            <input
              value={data.phone_number}
              name="phone_number"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Phone Number"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["phone_number"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div className="col-span-2">
            <label className={`primary-label`}>Company Name</label>
            <input
              value={data.company_name}
              name="company_name"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Company Name"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["company_name"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div className="col-span-2">
            <label className={`primary-label`}>Company Type</label>
            <input
              value={data.company_type}
              name="company_type"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Company type"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["company_type"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2 md:grid-cols-2 md:gap-4 mt-4">
          <div>
            <label className={`primary-label`}>Office Address</label>
            <input
              value={data.office_address}
              name="office_address"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Office Address"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["office_address"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className={`primary-label`}>Warehouse Address</label>
            <input
              value={data.warehouse_address}
              name="warehouse_address"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Warehouse Address"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["warehouse_address"]
                  ? "border-red-600"
                  : "border-gray-300"
              }`}
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-8 mt-4">
          <div>
            <label className={`primary-label`}>Representative Name</label>
            <input
              value={data.rep_name}
              name="rep_name"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Representative Name"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["rep_name"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className={`primary-label`}>TRN #</label>
            <input
              value={data.trn}
              name="trn"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="TRN"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["trn"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className={`primary-label`}>Rep Phone</label>
            <input
              value={data.rep_phone}
              name="rep_phone"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Rep Phone No."
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["rep_phone"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>

          {/* <div className="relative w-full">
            <label className="primary-label mb-1">Terms and Conditions</label>
            <Dropdown
              selected={isTermsOpen}
              placeholder="Select Term"
              options={dropdownOption}
              onChange={handleChange}
            />
          </div> */}

          <div className="relative w-full" ref={dropdownRef}>
            <label className="primary-label mb-1">Terms and Conditions</label>
            <Dropdown
              isOpen={isTermsOpen}
              onToggle={() => setIsTermsOpen(!isTermsOpen)}
              selected={selectedTerm}
              placeholder="Select Term"
              options={dropdownOption}
              onChange={(option) => {
                setSelectedTerm(option);
                setData((prev) => ({ ...prev, terms: option.value })); // ✅ update data.terms
                setErrors((prevState) => ({ ...prevState, terms: false })); // ✅ clear error if selected
                setIsTermsOpen(false); // close dropdown on selection
              }}
            />
          </div>
        </div>

        <div className="mt-4">
          <label className={`primary-label`}>Trading License</label>
          <input
            type="file"
            placeholder="Enter Part No."
            onChange={(e) => convertToBase64(e)}
            onKeyDown={handleKeyDown}
            className={`primary-input ${
              errors["license"] ? "border-red-600" : "border-gray-300"
            }
                                  file:mr-4 file:px-6 file:rounded-full
                                  file:border-0 file:text-[12px] file:font-semibold
                                  file:bg-white file:text-black
                                  hover:file:bg-primary hover:file:text-white`}
          />
        </div>
        <div>
          {responseError ? (
            <div className="text-red-600 text-sm">{responseError}</div>
          ) : (
            ""
          )}
        </div>
        <div className="flex items-center justify-center flex-col mt-12">
          <button
            onClick={() => handleSubmit()}
            disabled={loading}
            className={`bg-white text-black border font-medium text-xs px-8 py-4 rounded-lg shadow-sm hover:shadow-lg duration-300 transition-all flex flex-row items-center overflow-hidden group ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {loading ? (
              <LoadingDots />
            ) : (
              <>
                <HiPlus className="text-xl w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
                <div> Add Order</div>
              </>
            )}
          </button>
        </div>
      </div>
    </main>
  );
};

export default AddCustomer;
